<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-adelanto-sueldo'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>

      <template #table>
        <b-table
          ref="ref-table-adelanto-sueldo"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
          show-empty
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(employee_id)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.employee_id },
              }"
            >
              {{ data.item.full_name | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7">
              {{ data.item.area | capitalize }}
            </span>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="getStatusVariant(data.item.estado)">
              <span class="text-uppercase">
                {{ data.item.estado }}
              </span>
            </b-badge>
          </template>
          <template #cell(observacion)="data">
            <div
              style="
                max-width: 10vw;
                word-wrap: break-word;
                white-space: normal;
              "
            >
              {{ data.item.observacion }}
            </div>
          </template>
          <template #cell(total)="data">
            <span class="text-success">
              S/.{{ data.item.monto_total | currency }}
            </span>
          </template>
          <template #cell(quotas)="data">
            <span
              style="font-size: 15px"
              class="cursor-pointer"
              @click="openFractionsModal(data.item)"
            >
              <b-badge variant="light-info">
                {{ data.item.numero_cuotas }}
              </b-badge>
            </span>
          </template>
          <template #cell(created_by)="data">
            <span> {{ data.item.user_created | capitalize }} </span><br />
            <feather-icon
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            <span style="opacity: 0.7">
              {{ data.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(user_authorized)="data">
            <span v-if="data.item.user_authorized">
              {{ data.item.user_authorized | capitalize }} </span
            ><br />
            <feather-icon
              v-if="data.item.user_authorized"
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            <span v-if="data.item.user_authorized" style="opacity: 0.7">
              {{ data.item.approved_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(sustento)="data">
            <div class="d-flex flex-column">
              <div
                class="mb-1 d-flex align-items-center justify-content-between"
              >
                <small class="mr-1">SUSTENTO:</small>
                <b-link
                  v-if="data.item.sustento"
                  :href="data.item.sustento"
                  target="_blank"
                >
                  <feather-icon icon="FileIcon" class="text-primary" />
                </b-link>
                <span v-else>-</span>
              </div>

              <div
                v-if="data.item.estado == 'aprobado'"
                class="d-flex align-items-center justify-content-between"
              >
                <small class="mr-1">COMPROMISO:</small>

                <b-link
                  v-if="data.item.compromiso"
                  :href="data.item.compromiso"
                  target="_blank"
                >
                  <feather-icon
                    icon="FileIcon"
                    :class="data.item.firmado ? 'text-success' : 'text-warning'"
                  />
                </b-link>

                <span v-else>
                  -
                  <!-- {{ data.item.firmado ? "Firmado" : "No firmado" }} -->
                </span>
              </div>
            </div>
          </template>

          <template #cell(actions)="data">
            <feather-icon
              v-if="isCeo && data.item.compromiso && !data.item.firmado"
              icon="Edit3Icon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('Firmar compromiso')"
              @click="openFirmarCompromisoModal(data.item)"
            />

            <feather-icon
              v-if="data.item.estado == 'pendiente' && isCeo"
              icon="CheckSquareIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('Aprobar adelanto')"
              @click="openDiscountModal(data.item, 'approve')"
            />

            <feather-icon
              v-if="data.item.estado == 'pendiente'"
              icon="EditIcon"
              class="cursor-pointer text-warning ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Modificar adelanto')"
              @click="openDiscountModal(data.item, 'edit')"
            />

            <!-- <feather-icon
              v-if="tab != 'pending'"
              icon="ListIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('View Tracking')"
              @click="openDiscountTrackingModal(data.item)"
            /> -->

            <feather-icon
              v-if="data.item.estado == 'pendiente'"
              icon="Trash2Icon"
              class="cursor-pointer text-danger ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Anular adelanto')"
              @click="openDiscountModal(data.item, 'anulle')"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <FractionsModal
      v-if="fractionsModal"
      :modalData="modalData"
      origin="adelanto"
      @hideModal="fractionsModal = false"
    />
    <!-- 
    <DiscountTrackingModal
      v-if="discountTrackingModal"
      :modalData="modalData"
      @hideModal="discountTrackingModal = false"
    /> -->
    <DiscountModal
      v-if="discountModal"
      :modalData="modalData"
      :origin="'adelanto'"
      @hideModal="hideDiscountModal"
    />

    <FirmarCompromisoModal
      v-if="showFirmarCompromisoModal"
      :adelantoId="modalData.id"
      @hidden="hideFirmarCompromisoModal"
      @update="
        $refs['ref-table-adelanto-sueldo'].refresh(),
          hideFirmarCompromisoModal()
      "
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/rrhh/views/payroll/components/adelanto-sueldo/data/fields.js";
import Filters from "@/views/rrhh/views/payroll/components/adelanto-sueldo/data/filters.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

/* Modals */
import FractionsModal from "@/views/commons/discounts/components/modals/FractionsModal.vue";
import DiscountModal from "@/views/commons/discounts/components/modals/DiscountModal.vue";
import DiscountTrackingModal from "@/views/commons/discounts/components/modals/DiscountTrackingModal.vue";

/* Services */
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

import DiscountService from "@/views/commons/discounts/services/discounts.service.js";
import AdelantoSueldoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/adelanto.sueldo.service.js";
import FirmarCompromisoModal from "@/views/rrhh/views/payroll/components/adelanto-sueldo/components/FirmarCompromisoModal.vue";

export default {
  components: {
    FilterSlot,
    FractionsModal,
    DiscountModal,
    DiscountTrackingModal,
    FirmarCompromisoModal,
  },
  props: {
    tab: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      filters: Filters,
      params: 1,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      initDateSelect: "",
      modalData: {
        id: null,
      },
      fractionsModal: false,
      discountModal: false,
      discountTrackingModal: false,
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      weekly: "",
      firstCard: {
        title: "Pending Discounts",
        icon: 1,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
      secondCard: {
        title: "Pending Current Month Discounts",
        icon: 2,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
      showFirmarCompromisoModal: false,
    };
  },
  computed: {
    showFields() {
      this.fields.map((row) => (row.visible = true));

      let fieldsVisible = this.fields.filter((item) => item.visible);
      fieldsVisible = fieldsVisible.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
      return fieldsVisible;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await Promise.all([
      this.getAreas(),
      (this.filters[3].options = [
        { id: "pendiente", name: "Pendiente" },
        { id: "aprobado", name: "Aprobado" },
        { id: "anulado", name: "Anulado" },
      ]),
      //   this.getPendingDiscountsSum(),
    ]);
    this.initDateSelect = this.initDate;
  },
  methods: {
    async exportToExcel(ctx) {
      try {
        let order = 18;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "created_at":
            order = 18;
            break;
          default:
            order = 18;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: this.filters[3].model,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          module_id: this.currentUser.modul_id,
        };
        const response = await AdelantoSueldoService.exportToExcel(params);

        let filename = "ADELANTO_DE_SUELDOS.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    openFirmarCompromisoModal(data) {
      this.modalData.id = data.id;
      this.showFirmarCompromisoModal = true;
    },
    hideFirmarCompromisoModal() {
      this.modalData.id = null;
      this.showFirmarCompromisoModal = false;
    },
    openDiscountModal(data, action) {
      if (action == "edit" || action == "approve" || action == "anulle") {
        this.modalData.id = data.id;
        this.modalData.action = action;
        this.discountModal = true;
      }
    },
    // Usado por ref
    openModalDiscount() {
      this.modalData.id = null;
      this.modalData.action = null;
      this.modalData.discount_type_id = 2; // Adelanto Sueldo id
      this.discountModal = true;
    },
    // async getPendingDiscountsSum() {
    //   try {
    //     const { data } = await DiscountService.getPendingDiscountsSum();
    //     this.firstCard.total = data.total_pending_discounts;
    //     this.secondCard.total = data.current_month_pending_discounts;
    //   } catch (error) {
    //     this.showToastError(this.$t(error), "Error");
    //   }
    // },

    getStatusVariant(status) {
      switch (status) {
        case "pendiente":
          return "light-warning";
        case "aprobado":
          return "light-success";
        // case "Paid":
        //   return "light-primary";
        case "anulado":
          return "light-info";
      }
    },
    async myProvider(ctx) {
      try {
        let order = 18;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "created_at":
            order = 18;
            break;
          default:
            order = 18;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: this.filters[3].model,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          module_id: this.currentUser.modul_id,
        };
        const { data } = await AdelantoSueldoService.index(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    openFractionsModal(data) {
      this.modalData.id_adelanto = data.id;
      this.modalData.discount_id = data.discount_id;
      this.modalData.full_name = data.full_name;
      this.fractionsModal = true;
    },

    hideDiscountModal(action = false) {
      if (action == true) {
        this.refreshTable();
      }
      this.discountModal = false;
    },
    // openDiscountTrackingModal(data) {
    //   this.modalData.discount_id = data.id;
    //   this.modalData.full_name = data.full_name;
    //   this.discountTrackingModal = true;
    // },
    // async anulleDiscount(data) {
    //   try {
    //     const confirm = await this.showConfirmSwal();
    //     if (confirm.isConfirmed) {
    //       const params = {
    //         discount_id: data.id,
    //         user_id: this.currentUser.id,
    //       };
    //       const { data } = await DiscountService.anulleDiscount(params);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.removePreloader();
    //   }
    // },
    refreshTable() {
      this.$refs["ref-table-adelanto-sueldo"].refresh();
    },
  },
  watch: {
    initDateSelect(newVal, oldVal) {
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");
      //   this.fields[5].label =
      //     "Mon " + moment(newVal).startOf("week").add(1, "days").format("MM-DD");
      //   this.fields[6].label =
      //     "Tue " + moment(newVal).startOf("week").add(2, "days").format("MM-DD");
      //   this.fields[7].label =
      //     "Wed " + moment(newVal).startOf("week").add(3, "days").format("MM-DD");
      //   this.fields[8].label =
      //     "Thu " + moment(newVal).startOf("week").add(4, "days").format("MM-DD");
      //   this.fields[9].label =
      //     "Fri " + moment(newVal).startOf("week").add(5, "days").format("MM-DD");
      //   this.fields[10].label =
      //     "Sat " + moment(newVal).startOf("week").add(6, "days").format("MM-DD");
      //   this.fields[11].label =
      //     "Sun " + moment(newVal).startOf("week").add(7, "days").format("MM-DD");
      //   var a = moment(newVal).startOf("week").add(1, "days");
      //   var b = moment().startOf("week").add(1, "days");
      //   this.week = a.diff(b, "weeks");
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}
.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}
.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>
